import { replaceHtml } from '../utils/util';
import { luckysheetrefreshgrid } from '../global/refresh';
import { modelHTML } from './constant';
import { getSheetIndex } from '../methods/get';
import locale from '../locale/locale';
import Store from '../store';

const printSettingCtrl = {
    defaultSetting: {
        paper: 'A4',//纸张标识
        layout: 'portrait',
        // 纸张宽高
        width: 210,
        height: 297,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 10,
        marginRight: 10,
        showPrintBreak: false,
    },
    paperList:[{ paper: 'A5', width: 148, height: 210 },
        { paper: 'A4', width: 210, height: 297 },
        { paper: 'A3', width: 297, height: 420 },
        { paper: 'B5', width: 176, height: 250 },
        { paper: 'B4', width: 250, height: 353 },
        { paper: 'Letter', width: 216, height: 279 },
        { paper: 'Legal', width: 216, height: 355 },
        { paper: 'Executive', width: 184, height: 266 }],
    setting: null,
    createDialog: function(){
        let _this = this;

        const _locale = locale();
        const printText = _locale.printSetting;
        const toolbarText = _locale.print;
        const buttonText = _locale.button;

        $("#luckysheet-modal-dialog-mask").show();
        $("#luckysheet-printSetting-dialog").remove();

        let paperOption = '';
        _this.paperList.forEach(item=>{
            paperOption += `<option value="${item.paper}">${item.paper} ：${item.width}mm x ${item.height}mm</option>`;
        })

        let content =  `<div class="box">
                            <div class="box-item">
                                <label for="luckysheet-printSetting-dialog-paper">${printText.paper}：</label>
                                <select id="luckysheet-printSetting-dialog-paper">
                                    ${paperOption}
                                </select>
                            </div>
                            <div class="box-radio">
                                <label>${printText.layout}：</label>
                                <div class="radio-item">
                                    <input type="radio" id="luckysheet-printSetting-dialog-layout-portrait" name="layout" value="portrait" checked="checked">
                                    <label for="luckysheet-printSetting-dialog-layout-portrait">${printText.portrait}</label>
                                </div>
                                <div class="radio-item">
                                    <input type="radio" id="luckysheet-printSetting-dialog-layout-landscape" name="layout" value="landscape">
                                    <label for="luckysheet-printSetting-dialog-layout-landscape">${printText.landscape}</label>
                                </div>
                            </div>
                            <div class="box-margin">
                                <label for="luckysheet-printSetting-dialog-marginTop">${printText.marginTop}：</label>
                                <input type="number" id="luckysheet-printSetting-dialog-marginTop" placeholder="0">
                                <label for="luckysheet-printSetting-dialog-marginBottom">${printText.marginBottom}：</label>
                                <input type="number" id="luckysheet-printSetting-dialog-marginBottom" placeholder="0">
                            </div>
                            <div class="box-margin">
                                <label for="luckysheet-printSetting-dialog-marginLeft">${printText.marginLeft}：</label>
                                <input type="number" id="luckysheet-printSetting-dialog-marginLeft" placeholder="0">
                                <label for="luckysheet-printSetting-dialog-marginRight">${printText.marginRight}：</label>
                                <input type="number" id="luckysheet-printSetting-dialog-marginRight" placeholder="0">
                            </div>
                            <div class="check">
                                <input type="checkbox" id="luckysheet-printSetting-dialog-showPrintBreak">
                                <label for="luckysheet-printSetting-dialog-showPrintBreak">${printText.showPrintBreak}</label>
                            </div>
                        </div>`;

        $("body").append(replaceHtml(modelHTML, {
            "id": "luckysheet-printSetting-dialog",
            "addclass": "luckysheet-printSetting-dialog",
            "title": toolbarText.menuItemConfig,
            "content": content,
            "botton":  `<button id="luckysheet-printSetting-dialog-confirm" class="btn btn-primary">${buttonText.confirm}</button>
                        <button class="btn btn-default luckysheet-model-close-btn">${buttonText.cancel}</button>`,
            "style": "z-index:100003"
        }));
        let $t = $("#luckysheet-printSetting-dialog").find(".luckysheet-modal-dialog-content").css("min-width", 350).end(),
            myh = $t.outerHeight(),
            myw = $t.outerWidth();
        let winw = $(window).width(),
            winh = $(window).height();
        let scrollLeft = $(document).scrollLeft(),
            scrollTop = $(document).scrollTop();
        $("#luckysheet-printSetting-dialog").css({
            "left": (winw + scrollLeft - myw) / 2,
            "top": (winh + scrollTop - myh) / 3
        }).show();
        this.dataAllocation();
    },
    init: function (){
        let _this = this;

        //确认按钮
        $(document).off("click.confirm").on("click.confirm", "#luckysheet-printSetting-dialog-confirm", function(e){

            let historySetting = $.extend(true, {}, _this.setting);
            let currentSetting = $.extend(true, {}, _this.setting);

            currentSetting.paper = $("#luckysheet-printSetting-dialog-paper").val();
            currentSetting.layout = $(".radio-item input[type=radio][name=layout]:checked").val();
            currentSetting.marginTop = $("#luckysheet-printSetting-dialog-marginTop").val();
            currentSetting.marginBottom = $("#luckysheet-printSetting-dialog-marginBottom").val();
            currentSetting.marginLeft = $("#luckysheet-printSetting-dialog-marginLeft").val();
            currentSetting.marginRight = $("#luckysheet-printSetting-dialog-marginRight").val();
            currentSetting.showPrintBreak = $("#luckysheet-printSetting-dialog-showPrintBreak").is(':checked');

            _this.ref(
                historySetting,
                currentSetting,
                Store.currentSheetIndex
            );

            $("#luckysheet-modal-dialog-mask").hide();
            $("#luckysheet-printSetting-dialog").hide();
        })
    },
    dataAllocation: function(){
        let _this = this;
        let currentSetting = Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)].config['printSetting'] || this.defaultSetting;
        _this.setting = Object.assign({},currentSetting);
        $("#luckysheet-printSetting-dialog-paper").val(currentSetting.paper);
        $("#luckysheet-printSetting-dialog-layout-" + currentSetting.layout).prop("checked", true);
        $("#luckysheet-printSetting-dialog-marginTop").val(currentSetting.marginTop);
        $("#luckysheet-printSetting-dialog-marginBottom").val(currentSetting.marginBottom);
        $("#luckysheet-printSetting-dialog-marginLeft").val(currentSetting.marginLeft);
        $("#luckysheet-printSetting-dialog-marginRight").val(currentSetting.marginRight);
        $("#luckysheet-printSetting-dialog-showPrintBreak").prop("checked", currentSetting.showPrintBreak);
    },

    ref: function(historySetting, currentSetting, sheetIndex){
        let _this = this;
        if (Store.clearjfundo) {
            Store.jfundo.length  = 0;
            let redo = {};
            redo["type"] = "updatePrintSetting";
            redo["sheetIndex"] = sheetIndex;
            redo["historyPrintSetting"] = historySetting;
            redo["currentPrintSetting"] = currentSetting;
            Store.jfredo.push(redo);
        }

        _this.setting = currentSetting;
        Store.luckysheetfile[getSheetIndex(sheetIndex)].config['printSetting'] = currentSetting;

        setTimeout(function () {
            luckysheetrefreshgrid();
        }, 1);
    }
}

export default printSettingCtrl;
